/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Add to symmetry sets</h4>

<p>Add to the two sets of symmetric edges.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('566634082')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Y</b>: Add to symmetry set</li>
</ul>`;

export default function SymmetryTooltip() {
    return h('div', { innerHTML: body });
}
